// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".caption[data-v-6fee3140]{font-size:1.2em;background-color:#000;color:#fff}.message[data-v-6fee3140]{font-weight:700}", ""]);
// Exports
module.exports = exports;
